import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSharedAnalysisResults from './reducers/shared-analysis-results.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SharedAnalysisResultsEffects } from './effects/shared-analysis-results.effects';
import { SharedAnalysisResultsService } from './services/shared-analysis-results.service';
import { SharedAnalysisResultsStoreFacade } from './facades/shared-analysis-results-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromSharedAnalysisResults.sharedAnalysisResultsFeatureKey,
      fromSharedAnalysisResults.reducer
    ),
    EffectsModule.forFeature([SharedAnalysisResultsEffects]),
  ],
  providers: [SharedAnalysisResultsService, SharedAnalysisResultsStoreFacade],
})
export class SharedAnalysisResultsModule {}
